module.exports = __webpack_public_path__ + "media/images/device-band-153fd571.png";